import { useIntl } from 'react-intl';
export const useFormattedBytes = bytes => {
  const {
    formatMessage
  } = useIntl();
  if (!bytes && bytes !== 0) {
    return '';
  }
  const asMegabytes = bytes / 1000 ** 2;
  return asMegabytes > 1000 ? formatMessage({
    id: 'Storage.Media_Size_Label.GB'
  }, {
    amount: (asMegabytes / 1000).toFixed(1)
  }) : formatMessage({
    id: 'Storage.Media_Size_Label.MB'
  }, {
    amount: asMegabytes.toFixed(0)
  });
};
//# sourceMappingURL=useFormattedBytes.js.map